
import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { inCommands } from '../../../concepts/commands/CommandRegistry';
import { ObjectManager } from '../../../concepts/objects';
import { Point } from '../../../platform/geom/Point';
import { Rect } from '../../../platform/geom/Rect';
import { AdapterInfo, CreateAdapterInfo } from '../../canvas/AdapterInfo';
import { EditorSession } from '../../canvas/EditorSession';
import { resolveSubject, resolveSubjects } from '../../canvas/commands/CommandUtil';
import { place, unplace } from '../../canvas/commands/OrderCommands';
import { Phys } from '../../canvas/entities/Phys';
import { RelativeTo } from '../../canvas/entities/Physical';
import { EffectDirector, Effects } from '../../canvas/visualization/EffectDirector';
import { AutoLayout } from './AutoLayout';
import { AutoLayoutEngine } from './AutoLayoutEngine';
import { AutoLayoutSort } from './AutoLayoutSortOptions';
import { EnforcedFlexLayoutConfig, FlexLayout } from './FlexLayout';

export const autoLayout = defineCommand(
    'autoLayout',
    'Auto Layout',
    (cc, [targetId]: [string?]) => {

        const objects = cc.resolve(ObjectManager);
        const container = resolveSubject(cc, targetId, AutoLayout);
        if (!container) return;

        objects.update(() => {
            const engine = cc.call(AutoLayoutEngine);
            engine.refresh(container);
        });


    }
);

export const flexLayoutConfigure = defineCommand(
    'flexLayoutConfigure',
    'Flex Layout: Configure...',
    (cc) => {
        const session = cc.resolve(EditorSession);
        session.update(AdapterInfo, CreateAdapterInfo(
            'selection',
            'autoLayout',
        ));
    }
);

export const flexLayoutInArea = defineCommand(
    'flexLayout',
    'Flex Layout: In Area',
    (cc, [from, to, axis, align, justify, gap, sort, targetIds]: [Point, Point, ...EnforcedFlexLayoutConfig, string, string[]?]) => {

        const objects = cc.resolve(ObjectManager);
        const effects = cc.resolve(EffectDirector);
        const subjects = Phys.from(resolveSubjects(cc, targetIds)).takeHeads();
        if (!subjects) return;

        const area = Rect.fromPoints([from, to]);

        const [sortBy, sortOrder] = sort.split(':');
        const sortFn = AutoLayoutSort[sortBy]?.(cc) || AutoLayoutSort.none(cc);
        const sorted = subjects.toArray().toSorted(sortFn);

        if (sortOrder === 'desc') {
            sorted.reverse();
        }

        const befores = new Map(sorted.map(x => [x, x.transform(RelativeTo.Model)]));

        objects.update(u => {
            u.rolling('layout', subjects.toArray());
            cc.dispatch(unplace, [subjects.toArrayOfIds()]);
            FlexLayout.exec(area, [axis, align, justify, gap], sorted);
            cc.dispatch(place, [subjects.toArrayOfIds()]);

            const afters = new Map(sorted.map(x => [x, x.transform(RelativeTo.Model)]));
            for (const elmt of sorted) {
                const b = befores.get(elmt);
                const a = afters.get(elmt);
                if (!b.equals(a)) {
                    effects.trigger(Effects.tween(b, a), elmt);
                }
            }
        });

    }
);


export const inAutoLayoutCommands = () => inCommands(
    autoLayout,
    flexLayoutConfigure,
);

